// Helpers (simulent les appels serveur / génération)
import {useEffect, useState} from "react";

export function formatCurrency(v) {
    return v.toLocaleString("fr-FR", {style: "currency", currency: "EUR"});
}

export function roundToTwo(num) {
    return Math.round((num + Number.EPSILON) * 100) / 100;
}

/**
 * Calcule les détails de prix arrondis pour une ligne (produit ou option).
 * @param price Prix unitaire HT
 * @param quantity Quantité
 * @param tva Taux de TVA (ex: 20)
 * @param reductionPercent Pourcentage de réduction (ex: 10)
 * @param coef Coefficient multiplicateur (ex: 1.5 pour les jours)
 */
export function calculatePriceDetails(price, quantity, tva, reductionPercent = 0, coef = 1) {
    const totalHTWithoutReduction = roundToTwo(price * quantity * coef);
    const reductionAmount = roundToTwo(totalHTWithoutReduction * (reductionPercent / 100));
    const totalHT = roundToTwo(totalHTWithoutReduction - reductionAmount);
    const tvaAmount = roundToTwo(totalHT * (tva / 100));
    const totalTTC = roundToTwo(totalHT + tvaAmount);

    return {
        totalHTWithoutReduction,
        reductionAmount,
        totalHT,
        tvaAmount,
        totalTTC
    };
}

export function formatDateISO(iso) {
    const d = new Date(iso);
    return iso ? d.toLocaleString("fr-FR", {dateStyle: "medium", timeStyle: "short", timeZone: "Europe/Paris"}) : "";
}

export function formatDateISOSmall(iso) {
    const d = new Date(iso);
    // Format DD/MM/YY HH:MM
    return iso ? d.toLocaleString("fr-FR", {dateStyle: "short", timeStyle: "short", timeZone: "Europe/Paris"}) : "";
}

export function formatDateOnlyISO(iso) {
    const d = new Date(iso);
    return iso ? d.toLocaleDateString("fr-FR", {dateStyle: "short", timeZone: "Europe/Paris"}) : "";
}

export function calculateReduction(price, quantity, discountType, discountValue, options = []) {
    let total = price * quantity;

    // Ajouter le prix des options
    options.forEach((option) => {
        total += option.price * option.quantity;
    });

    let res = 0;
    if (discountType === 'percent') {
        res = total * (discountValue / 100);
    } else if (discountType === 'fixed') {
        res = discountValue;
    }

    return res;
}

export function calculateSubtotal(list) {
    let res = 0;
    list.forEach((item) => {
        const {price, quantity, discountType, discountValue, options} = item;
        res += price * quantity - calculateReduction(price, quantity, discountType, discountValue, options);
        options.forEach((option) => {
            res += option.price * option.quantity;
        });
    })
    return res;
}

export function useIsMobile(threshold = 600) {
    const [isMobile, setIsMobile] = useState(window.innerWidth < threshold);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < threshold);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [threshold]);

    return isMobile;
}

export function getCurrentDateForInput() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}